import { securityItems } from "../data/landingData";
import Icon from "./Icons";

export default function SecuritySection() {
  return (
    <section id="security" className="section security">
      <div className="security-inner">
        <div className="security-intro">
          <h2 className="security-title">
            Comment SAFE protège vos données,{" "}
            <span className="neon-text">couche par couche</span>
          </h2>
          <p className="security-desc">
            SAFE combine chiffrement militaire, architecture zero-knowledge et
            contrôle système profond pour offrir une protection que les
            applications classiques ne peuvent pas égaler.
          </p>
        </div>
        <div className="security-list">
          {securityItems.map((item, i) => (
            <div key={i} className="security-item">
              <div className="security-item-icon">
                <Icon name={item.icon} />
              </div>
              <div className="security-item-content">
                <h3 className="security-item-title">{item.title}</h3>
                <p className="security-item-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
